module.exports = __webpack_public_path__ + "static/img/Frame-56-2.574ba50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Frame-56-2.jpg
// module id = QF/u
// module chunks = 1